export default __webpack_public_path__ + "static/media/sgj-english.b4353c55.svg";